<div class="order-wrapper">
  <div class="order-header" *ngIf="!common.isMobileMode">
    <order-header (onStateChange)="order.setActivePage($event)" (onBtnClicked)="headerClickHandler($event)"></order-header>
  </div>
  <div class="order-main" (window:resize)="onResize($event)">
    <order-fast-access>
      <ng-container class="content">
        <ng-container *ngIf="!common.isMobileMode; else mobileTemplate">
          <div class="order-desk" *ngIf="order.currentActivePage === order.activePageEnum.Order">
            <div class="item" #container [style.width.px]="data.width" style="height: 100%">
              <order-item></order-item>
            </div>
            <div
              class="resize resize__left"
              (resize)="Resize($event)"
              (resizeEnd)="resizeEnd($event)"
              [targetElement]="container"
              [direction]="AngularResizeElementDirection.LEFT"></div>
            <div class="item">
              <order-invoice></order-invoice>
            </div>
          </div>
        </ng-container>

        <ng-template #mobileTemplate>
          <order-item [ngClass]="order.currentActivePage === order.activePageEnum.OrderItem ? '' : 'd-none'"></order-item>
          <order-invoice [ngClass]="order.currentActivePage === order.activePageEnum.Invoice ? '' : 'd-none'"></order-invoice>
        </ng-template>

        <order-salon
          *ngIf="!!order.currentSaleMethodNature && this.order.saleMethodBranch"
          [ngClass]="order.currentActivePage === order.activePageEnum.Salon ? '' : 'd-none'">
        </order-salon>
        <order-customer [ngClass]="order.currentActivePage === order.activePageEnum.Customer ? '' : 'd-none'"></order-customer>
        <order-invoices
          #invoices
          *ngIf="order.itemCategoryList?.length > 0 && !!order.currentSaleMethodNature"
          [currentSaleMethodBranch]="order.saleMethodBranch"
          [currentFilter]="currentInvoicesFilter"
          [ngClass]="order.currentActivePage === order.activePageEnum.Invoices ? '' : 'd-none'"></order-invoices>
        <order-online
          *ngIf="
            order.logInBranch?.HasOrderOnline &&
            order.itemCategoryList?.length > 0 &&
            !!order.currentSaleMethodNature &&
            order.saleMethodBranch.HasDelino
          "
          [ngClass]="order.currentActivePage === order.activePageEnum.OnlineFactor ? '' : 'd-none'">
        </order-online>
        <order-reserve-online *ngIf="order.currentActivePage === order.activePageEnum.ReserveOnline"> </order-reserve-online>
      </ng-container>
    </order-fast-access>
  </div>

  <order-footer *ngIf="common.isMobileMode"></order-footer>
</div>
